var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subpage-navigation",class:{
    inline: _vm.inline,
    container: !_vm.inline,
    showOnMobile: _vm.showOnMobile,
  },style:(_vm.style)},[_c('div',{class:{ row: !_vm.inline }},[_c('div',{class:{
        'col-12 offset-0 col-xl-10 offset-xl-1': !_vm.inline,
      }},[(_vm.prev)?_c('ArrowButton',{staticClass:"btn prev",attrs:{"prev":true},on:{"click":_vm.onClick}}):_vm._e(),(_vm.next)?_c('ArrowButton',{staticClass:"btn next",on:{"click":_vm.onClick}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }